import { createLogger } from "@/infra/logging/logger";

export const validationWorkerLog = createLogger("SCANNER");
